import React from 'react';
import ProductItem from '../screens/markets/productItem';
import ProductItemNew from '../screens/markets/ProductItemNew';

class ProductGroup extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
          buyExpanded: false,
          sellExpanded: false,
          buyIsGlowing: false,
          sellIsGlowing: false,
          isExpanded: false,
        }

        this.renderSection = this.renderSection.bind(this);
        this.onExpand = this.onExpand.bind(this);
        this.setIsGlowing = this.setIsGlowing.bind(this);
    }

    componentDidMount() {
        this.setIsGlowing(this.props, 'buy');
        this.setIsGlowing(this.props, 'sell');
    }

    componentWillReceiveProps(nextProps) {
        this.setIsGlowing(nextProps, 'buy');
        this.setIsGlowing(nextProps, 'sell');
    }

    onExpand(intent) {
        let key = intent == 'buy' ? 'buyExpanded' : 'sellExpanded';
        this.setState({
          ...this.state,
          [key]: !this.state[key],
          isExpanded: !this.state.isExpanded,
        });
    }

    setIsGlowing(props, intent) {
        const stateKey = intent === 'buy' ? 'buyIsGlowing' : 'sellIsGlowing';
        const data = intent === 'buy' ? props.group.BUY : props.group.SELL;

        let maxGlowTime = 0;
        (data || []).forEach((row, idx) => {
            if (idx === 0) {
                return;
            }
            
            const { created_seconds_ago, updated_seconds_ago } = row;
            const glowTime = typeof updated_seconds_ago === 'number' 
                ? (300 - updated_seconds_ago) 
                : (300 - created_seconds_ago);            
            maxGlowTime = glowTime > maxGlowTime ? glowTime : maxGlowTime;            
        });
        
        this.setState({ [stateKey]: maxGlowTime > 0 });
        
        if (maxGlowTime > 0) {
            if (intent === 'buy') {
                clearTimeout(this.buyTimeout);
                this.buyTimeout = setTimeout(() => this.setState({ [stateKey]: false }), 1000 * maxGlowTime);
            } else {
                clearTimeout(this.sellTimeout);
                this.sellTimeout = setTimeout(() => this.setState({ [stateKey]: false }), 1000 * maxGlowTime);
            }
        }
    }

    renderSection(data, intent, collapsedClass) {
      if (!data || !data.length) return '';

      const isExpanded = intent == 'buy' ? this.state.buyExpanded : this.state.sellExpanded;
      const isGlowing = intent == 'buy' ? this.state.buyIsGlowing : this.state.sellIsGlowing;
      return data.map( (row, rowIndex) =>
          <ProductItem
              key={`ProductGroup_row_${row.id}`}
              row={row}
              isVisible={rowIndex==0 || isExpanded}
              isExpanded={isExpanded}
              collapsedClass={!isExpanded && rowIndex==0 ? collapsedClass : ''}
              onExpand={() => this.onExpand(intent)}
              showExpandButton={rowIndex == 0 && data.length > 1}
              glowExpandButton={rowIndex == 0 && isGlowing && !isExpanded}
              orderHasExpired={this.props.orderHasExpired}
              {...this.props} />
      );
    }

    renderSectionOpen(data) {
        if (!data || (!data.BUY && !data.SELL)) return '';

        const { isExpanded, buyIsGlowing, sellIsGlowing } = this.state;
        const isGlowing = buyIsGlowing || sellIsGlowing;
        const sectionBuy = data.BUY;
        const sectionSell = data.SELL;        
        const max_rows = sectionBuy.length > sectionSell.length 
            ? sectionBuy.length
            : sectionSell.length;        
        const rows = [];

        for (let i = 0; i < max_rows; i++) {
            rows.push(
                <ProductItemNew
                    key={`ProductGroup_openrow_${i}`}
                    dataBuy={sectionBuy[i] || false}
                    dataSell={sectionSell[i] || false}
                    isVisible={i == 0 || isExpanded}
                    isExpanded={isExpanded}
                    onExpand={this.onExpand}
                    showExpandButton={i == 0 && max_rows > 1}
                    glowExpandButton={i == 0 && isGlowing && !isExpanded}
                    orderHasExpired={this.props.orderHasExpired}
                    buyIsGlowing={buyIsGlowing}
                    sellIsGlowing={sellIsGlowing}
                    {...this.props}
                />
            );
        }

        return rows;
    }

    render() {
        const isFirstItem = this.props.isFirstItem;
        const isFirstNotOpenGroup = this.props.isFirstNotOpenGroup;
        const isFirstForProduct = this.props.isFirstForProduct;
        const sectionBuy = this.props.group.BUY;
        const sectionSell = this.props.group.SELL;
        const collapsedClassBuy = sectionSell.length ? 'rounded_top' : 'rounded_both';
        const collapsedClassSell = sectionBuy.length ? 'rounded_bottom' : 'rounded_both';
        const product_name = (sectionBuy[0] && sectionBuy[0].product_short_name) ||
            (sectionSell[0] && sectionSell[0].product_short_name);
      
        const result = [];
        if (isFirstNotOpenGroup) {
            result.push(<div className='group-separator big' />); 
        }
        if (isFirstForProduct) {
            if (!isFirstItem) {
                result.push(<tr  key='ProductGroup_1'><td className='worklog-productname-separator' colSpan="10"><hr /></td></tr>);
            }
            result.push(<tr  key='ProductGroup_2'><td className='worklog-productname-row' colSpan="10">{product_name}</td></tr>)
        }
        if (this.props.open) {
            result.push(...this.renderSectionOpen(this.props.group));
        } else {
            result.push(...this.renderSection(sectionBuy, 'buy', collapsedClassBuy));
            result.push(...this.renderSection(sectionSell, 'sell', collapsedClassSell));
        }
        
        return result;
    }
}
export default ProductGroup;


// WEBPACK FOOTER //
// ./source/components/ProductGroup.js